export const uiCapabilities = {
  admin: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canAccessFilesSection: true,
    canUpdateCustomer: true,
    canOpenOrderTrackingLink: true,
  },

  assistant_admin: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canAccessFilesSection: true,
    canUpdateCustomer: true,
    canOpenOrderTrackingLink: true,
  },

  order_management_specialist: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canUpdateCustomer: false,
    canOpenOrderTrackingLink: true,
  },

  order_management_associate: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: true,
    canUpdateCustomer: false,
    canOpenOrderTrackingLink: true,
  },

  delivery_associate: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: true,
    canUpdateCustomer: false,
    canOpenOrderTrackingLink: false,
  },

  e_commerce_admin: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: false,
    canUpdateCustomer: false,
    canOpenOrderTrackingLink: false,
  },

  content_manager: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: false,
    canAccessFilesSection: true,
    canUpdateCustomer: false,
    canOpenOrderTrackingLink: false,
  },
};
